import { render } from "./SystemAdmin8.vue?vue&type=template&id=d014df44"
import script from "./SystemAdmin8.vue?vue&type=script&lang=js"
export * from "./SystemAdmin8.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__